module.exports = __webpack_public_path__ + "img/wx2.c968d4f2.jpg";